import { Injectable, Output, EventEmitter } from '@angular/core';
import { CustomInput } from 'components/input/custom-input/custom-input.component';

@Injectable()
export class InputContainerService {
	private inputs: CustomInput[] = [];
	@Output() resized = new EventEmitter();

	add(input: CustomInput) {
		this.inputs.push(input);
	}
	remove(input: CustomInput) {
		const index = this.inputs.indexOf(input);
		if (index >= 0) this.inputs.splice(index, 1);
	}
	focus() {
		if (this.inputs.length > 0) this.inputs[0].setFocus(true);
	}
}
